export default {
  REGISTRAR_USER: 'REGISTRAR_USER',
  REGISTRAR_USER_ORG: 'REGISTRAR_USER_ORG',
  REGISTRAR_USER_ORG_RESULT: 'REGISTRAR_USER_ORG_RESULT',
  REGISTRAR_USER_3: 'REGISTRAR_USER_3',
  SIGN_SMS: 'SIGN_SMS',
  ERROR_DIALOG: 'ERROR_DIALOG',
  PASSWORD: 'PASSWORD',
  PASSWORD_HINT: 'PASSWORD_HINT',
  USER_INFO: 'USER_INFO',
  ERROR_FORM: 'ERROR_FORM'
};



// WEBPACK FOOTER //
// ./src/store/forms/formsConfigs/constants.js